import { LOCATIONS_DEFAULT } from "./Locations.default.graphql";

let LocationsFragment = LOCATIONS_DEFAULT;
export { LocationsFragment };
